module.exports = __webpack_public_path__ + "img/ubicacion.8f4bb5e6.png";